module.exports = __webpack_public_path__ + "img/3.cfc122b1.png";